<template>
  <div class="board-comments">
    <div class="form-comment mb-5">
      <div class="bg-white">
        <div class="mb-3">
          <button type="button" @click="addNew = 'comment'"
            :class="['btn btn-sm', (addNew == 'comment') ? 'btn-info' : 'btn-outline-secondary']">Comment</button>
          <button type="button" @click="addNew = 'code'"
            :class="['btn btn-sm ml-3', (addNew == 'code') ? 'btn-info' : 'btn-outline-secondary']">Code Snippet</button>
          <button type="button" @click="addNew = 'files'"
            :class="['btn btn-sm ml-3', (addNew == 'files') ? 'btn-info' : 'btn-outline-secondary']">Files</button>
        </div>
        <div v-show="addNew == 'comment'">
          <div class="form-group">
            <div id="commentInput" style="height: 150px;background: white;"></div>
          </div>
          <button type="button" class="btn btn-primary" @click="addComment"
            :disabled="state == 'submitting' || comment == ''">
            {{ state == 'submitting' ? 'Please wait...' : 'Submit' }}
          </button>
        </div>

        <div v-show="addNew == 'code'">
          <div class="form-group">
            <codemirror v-model="code" :options="cmOpts"></codemirror>
          </div>
          <button type="button" class="btn btn-primary" @click="submitCode"
            :disabled="state == 'submitting' || code == ''">
            {{ state == 'submitting' ? 'Please wait...' : 'Submit' }}
          </button>
        </div>

        <div v-show="addNew == 'files'">
          <div class="uppy-container"></div>
        </div>
      </div>
    </div>

    <div class="list-comments">
      <div v-for="(comment, index) in comments" :key="index" :id="'comment-' + index" class="comment">
        <span class="avatar" v-tooltip="comment.author.full_name">{{ comment.author.initials }}</span>
        <span class="datetime"><a href="javascript:;" class="text-danger" v-if="objectService" @click="confDelete(comment.id)"> <small><i class="fa fa-remove"></i> Delete</small></a> {{ comment.created_at | fromNow }}</span>
        <div class="comment-body">
          <div v-if="comment.type == 'code'">
            <codemirror v-model="comment.content"
                        :options="{
              tabSize: 2,
              styleActiveLine: true,
              lineNumbers: true,
              lineWrapping: true,
              line: true,
              foldGutter: true,
              styleSelectedText: true,
              matchBrackets: true,
              showCursorWhenSelecting: true,
              theme: 'cobalt',
              readOnly: true
            }"></codemirror>
          </div>
          <div v-if="comment.type != 'code'" v-html="comment.content"></div>
        </div>
      </div>
      <div class="loading text-white" v-if="state == 'loading'">Loading comments...</div>

      <button type="button" class="btn btn-block btn-outline-light"
        v-if="(currentPage < totalPages) && (state != 'loading')" @click="loadMore">Load more comments</button>
    </div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {unionBy} from 'lodash'
  import Job from '@/services/job'

  import Quill from 'quill'
  import 'quill-mention'

  import {codemirror} from 'vue-codemirror'
  import 'codemirror/mode/css/css.js'
  import 'codemirror/mode/htmlembedded/htmlembedded.js'
  import 'codemirror/mode/htmlmixed/htmlmixed.js'
  import 'codemirror/mode/javascript/javascript.js'
  import 'codemirror/mode/php/php.js'
  import 'codemirror/mode/sass/sass.js'
  import 'codemirror/mode/sql/sql.js'
  import 'codemirror/mode/vue/vue.js'

  import Uppy from '@uppy/core'
  import Dashboard from '@uppy/dashboard'
  import XHRUpload from '@uppy/xhr-upload'

  export default {
  components: {
    codemirror
  },
  data () {
    return {
      state: '',
      addNew: 'comment',
      comments: [],
      currentPage: 1,
      totalPages: 0,
      comment: '',
      tribute: null,
      froala: null,
      quill: null,
      code: '',
      cmOpts: {
        tabSize: 2,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleSelectedText: true,
        // mode: 'text/javascript',
        // keyMap: "sublime",
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: "cobalt"
      },
      uppy: null
    };
  },
  props: ['objectId', 'objectType', 'board', 'taggableItems'],
  computed: {
    ...mapGetters(['OPTIONS']),
    objectService () {
      let self = this;
      if ( self.objectType == 'job' ) {
        return Job;
      }
      return null;
    },
  },
  watch: {
    addNew ( newVal ) {
      let self = this;
      if ( newVal == 'files' ) {
        self.$nextTick(() => {
          self.initUppy();
        });
      }
      else if ( self.uppy ) {
        self.uppy.close();
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;

      self.quill = new Quill('#commentInput', {
        modules: {
          mention: {
            allowedChars: /^[a-zA-Z0-9_]*$/,
            mentionDenotationChars: ['@'],
            // eslint-disable-next-line
            source (searchTerm, renderList, mentionChar) {
              let values;
              values = self.taggableItems;
              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              }
              else {
                const matches = [];
                for (let i = 0; i < values.length; i++)
                  if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            },
          },
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'color': [] }, { 'background': [] }],
            // ['link', 'image', 'code-block']
          ],
        },
        placeholder: 'Write a comment...',
        theme: 'snow'
      });

      // eslint-disable-next-line
      self.quill.on('text-change', (delta, oldDelta, source) => {
        self.comment = self.quill.container.firstChild.innerHTML;
      });

      self.getComments();
    },
    initUppy () {
      let self = this;
      const accessToken = self.$localStorage.get('access_token');

      self.uppy = Uppy({
        restrictions: {
          maxFileSize: self.OPTIONS.upload_max_filesize,
          maxNumberOfFiles: null,
          minNumberOfFiles: null,
          allowedFileTypes: null
        }
      })
      .use(Dashboard, {
        inline: true,
        target: '.uppy-container',
        replaceTargetContent: true,
        height: 300,
      })
      .use(XHRUpload, {
        endpoint: process.env.VUE_APP_APIURL + 'files/upload',
        fieldName: 'file_upload',
        headers: {
          'Authorization': 'Bearer ' + accessToken
        }
      });

      // eslint-disable-next-line
      self.uppy.on('file-added', file => {
        self.uppy.setMeta({
          type: 'comment',
          object_type: self.objectType,
          object_id: self.objectId,
          board: self.board,
        })
      })

      self.uppy.on('upload-success', (file, resp) => {
        // self.$notify({
        //   type: 'success',
        //   text: 'File uploaded successfully'
        // });
        self.comments.unshift( resp.body.comment );
        self.$store.commit('ADD_ATTACHMENT', resp.body.file );
      })
    },
    addComment () {
      let self = this;
      if ( !self.objectService || self.state != '' ) return;

      let postData = {
        board: self.board,
        comment: self.comment
      };

      self.state = 'submitting';

      self.objectService.addComment(self.objectId, postData, comment => {
        self.state = '';
        self.comment = '';
        self.quill.setContents([]);
        self.$notify({
          type: 'success',
          text: 'Your comment posted successfully'
        });
        self.comments.unshift(comment);
      }, () => {
        self.state = '';
      });
    },
    submitCode () {
      let self = this;
      if ( !self.objectService || self.state != '' ) return;

      let postData = {
        board: self.board,
        comment: self.code,
        type: 'code'
      };

      self.state = 'submitting';

      self.objectService.addComment(self.objectId, postData, comment => {
        self.state = '';
        self.code = '';
        self.$notify({
          type: 'success',
          text: 'Code snippet posted successfully'
        });
        self.comments.unshift( comment );
      }, () => {
        self.state = '';
      });
    },
    loadMore () {
      let self = this;
      if ( self.currentPage < self.totalPages ) {
        self.currentPage++;
        self.getComments();
      }
    },
    confDelete (comment_id) {
      let self = this;
      if ( !self.objectService ) return;
      if ( self.state != '' ) return;
      let msg = 'Are you sure you want to delete this discussion record?';

      self.$dialog.confirm( msg, {
        html: true,
        loader: true,
        okText: "Yes, I'm sure",
        cancelText: "Cancel",
      } )
        .then(dialog => {
          self.objectService.deleteComment(self.objectId, comment_id, (result) => {
            dialog.close();
            if (result.status == 'SUCCESS') {
              self.$notify({
                type: 'success',
                text: 'Selected comment is deleted'
              });
              self.getComments();
            } else {
              self.$notify({
                type: 'error',
                title: 'Invalid Request',
                text: result.error,
              });
            }
          });
        })
        .catch(() => {})
    },
    getComments () {
      let self = this;
      if ( !self.objectService ) return;
      if ( self.state != '' ) return;

      let params = {
        board: self.board,
        page: self.currentPage,
      };

      self.state = 'loading';
      self.objectService.getComments(self.objectId, params, resp => {
        self.state = '';
        self.totalPages = resp.last_page;
        if ( self.currentPage == 1 ) {
          self.comments = resp.data;
        }
        else {
          self.comments = unionBy( self.comments, resp.data, 'id' );
        }
      });
    },
  }
}
</script>

<style lang="scss">
.CodeMirror {
  height: 200px;
}
</style>
